import * as Y from "yjs";
import { CodemirrorBinding } from "y-codemirror";
import { WebrtcProvider } from "./y-webrtc";
import CodeMirror from "codemirror";
import { useEffect, useState, useRef } from "react";
import { useParams, useHistory } from "react-router-dom";
import "codemirror/lib/codemirror.css";
import "./styles/lucario.css";
import "codemirror/mode/clike/clike";
import "codemirror/addon/hint/show-hint";
import "codemirror/addon/comment/comment";
import "codemirror/addon/lint/lint";

import { randomHex } from "randomize-hex";
import useShaderManager from "./useShaderManager";
import useYDocsManager from "./useYDocsManager";
import useCanvasManager from "./useCanvasManager";

const Editor = () => {
  const updateYDocsManager = useYDocsManager((state) => state.update);

  const parseErrors = (errors, output) => {
    for (var i = 0; i < errors.length; i++) {
      var error = errors[i];
      if (error) {
        if (Number(error.line) <= 0) {
          console.warn(
            "Cannot display error (invalid line " + error.line + ")",
            error
          );
          continue;
        }

        var start = error.character - 1,
          end = start + 1;

        // Convert to format expected by validation service
        var hint = {
          message: error.message,
          severity: "error",
          from: CodeMirror.Pos(Number(error.line) - 1, start),
          to: CodeMirror.Pos(Number(error.line) - 1, end),
        };
        output.push(hint);
      }
    }
  };

  const errors = useShaderManager((state) => state.errors);
  const validator = () => {
    var result = [];
    if (errors) parseErrors(errors, result);
    return result;
  };

  CodeMirror.registerHelper("lint", "x-shader/x-vertex", validator);

  const [name, setName] = useState("");
  const [color, setColor] = useState("#afb");
  const codeMirrorRef = useRef();
  const [init, setInit] = useState(false);
  const updateState = useShaderManager((state) => state.update);
  const [webrtcprovider, setProvider] = useState(null);
  const { showEditor } = useShaderManager((state) => state);
  let { id } = useParams();
  const updateCanvas = useCanvasManager((state) => state.update);
  const deletePeer = useCanvasManager((state) => state.deletePeer);

  const connect = (room, callback) => {
    try {
      const ydoc = new Y.Doc();

      const signalingServer =
        process.env.NODE_ENV == "development"
          ? `ws://${process.env.REACT_APP_LOCAL_IP}:${process.env.REACT_APP_PORT}`
          : process.env.REACT_APP_SIGNALING_SERVER;

      const provider = new WebrtcProvider(room, ydoc, {
        signaling: [signalingServer],
      });

      setProvider(provider);
      const yText = ydoc.getText("codemirror");

      const yState = ydoc.getMap("state");

      yState.set("frag", false);
      yState.set("drawing", {});

      updateState("yState", yState);
      updateYDocsManager("yState", yState);

      yState.observe((event) => {
        if (event.keysChanged.has("frag")) {
          const code = yText.toString();
          callback(code);
        }
        if (event.keysChanged.has("drawing")) {
          updateCanvas("peers", yState.get("drawing"));
        }
      });

      if (yText.toString.length == 0) {
        // console.log("inserting checkpoint 1", yText.toString().length)
        // const code = state.checkpoint1;
        // yText.insert(0,code);
      }

      const yUndoManager = new Y.UndoManager(yText);

      const e = new CodeMirror(codeMirrorRef.current, {
        mode: "x-shader/x-fragment",
        lineNumbers: true,
        theme: "lucario",
        lineWrapping: true,
        smartIndent: true,
        lineNumbers: true,
        foldGutter: true,
        tabSize: 2,
        gutters: ["CodeMirror-linenumbers", "CodeMirror-lint-markers"],
        lint: true,
      });

      updateState("editorRef", e);

      window.binding = new CodemirrorBinding(yText, e, provider.awareness, {
        yUndoManager,
      });

      window.binding.awareness.setLocalStateField("user", {
        color: color,
        name: name,
      });
      setInit(true);
    } catch (e) {
      console.log("Something went wrong when trying to create connection", e);
    }
  };

  useEffect(() => {
    if (id && !init) {
      const callback = (code) => updateState("fragCode", code);
      connect(id, callback);
    }

    return () => {
      if (webrtcprovider) {
        deletePeer(webrtcprovider.room.peerId);
        webrtcprovider.destroy();
      }
    };
  }, [id, updateState, init]);

  useEffect(() => {
    if (webrtcprovider && webrtcprovider.room) {
      const peerId = webrtcprovider.room.peerId;
      updateYDocsManager("id", peerId);
    }
  }, [webrtcprovider]);

  return (
    <div style={showEditor ? { display: "block" } : { display: "none" }}>
      <div className="horizontal-bar">
        {/* <div className= "bar-text" >Nombre: </div> */}
        <input
          className="bar-input"
          type="text"
          value={name}
          placeholder="nombre y pronombres"
          onChange={(e) => {
            setName(e.target.value);
            window.binding.awareness.setLocalStateField("user", {
              color: "#008833",
              name: e.target.value,
            });
          }}
          size="15"
          id="name"
        />
        <button
          className="bar-button"
          style={{ backgroundColor: color }}
          onClick={() => {
            let c = randomHex();
            setColor(c);
            updateCanvas("color", c);
            window.binding.awareness.setLocalStateField("user", {
              color: c,
              name: name,
            });
            var r = document.querySelector(":root");
            r.style.setProperty("--user-color", c);
          }}
        >
          🌈
        </button>
      </div>
      <div ref={codeMirrorRef}></div>
    </div>
  );
};

export default Editor;

/**
 * 
 *  , {
        signaling: [
         
        ]
      })

`)};
 */
